import { fetcher } from '@commenda/utils';
import { AssignmentResponse } from './types';

export async function assignUserToSalesTaxFiling(
  filingId: string,
  userId: string,
  corporation_id: number
): Promise<AssignmentResponse> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}/assign-user/${userId}?corporation_id=${corporation_id}`,
      {
        method: 'POST',
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to assign user',
      };
    }

    return {
      success: true,
      data: data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
